import {Component, OnDestroy, OnInit} from "@angular/core";
import {ActivatedRoute} from "@angular/router";
import {map, Subscription} from "rxjs";
import {EmailType, UnsubscribeService} from "./unsubscribe.service";
import {FormBuilder, FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {NgForOf, NgIf} from "@angular/common";
import {NgbAlert} from "@ng-bootstrap/ng-bootstrap";

@Component({
    standalone: true,
    selector: 'app-round',
    templateUrl: './unsubscribe.component.html',
    imports: [
        ReactiveFormsModule,
        NgForOf,
        NgbAlert
    ],
    styleUrls: ['./unsubscribe.component.css']
})
export class UnsubscribeComponent implements OnInit, OnDestroy {
    private formBuilder = new FormBuilder().nonNullable
    private subscriptions: Subscription[] = [];
    private token: string = "";

    private marketing: [EmailType, FormControl<boolean>] = [EmailType.Marketing, this.formBuilder.control(false)]
    private rounds: [EmailType, FormControl<boolean>] = [EmailType.RoundSharing, this.formBuilder.control(false)]

    alerts: Alert[] = [];
    isLoading: boolean = false
    form: FormGroup = new FormGroup({
        marketing: this.marketing[1],
        rounds: this.rounds[1]
    });

    constructor(private route: ActivatedRoute, private service: UnsubscribeService) {

    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.route.queryParams
                .pipe(map(params => params["token"]))
                .subscribe(token => this.token = token)
        )
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    send() {
        let types = [this.marketing, this.rounds]
            .filter(([_, control]) => control.value)
            .map(([name, _]) => name)

        this.isLoading = true
        this.alerts = []
        this.subscriptions.push(
            this.service.unsubscribe(this.token, types)
                .subscribe({
                        next: () => {
                            this.isLoading = false
                            this.showAlert("success", "Email preferences updated")
                        },
                        error: () => {
                            this.isLoading = false
                            this.showAlert("danger", "Failed to update preferences")
                        }
                    }
                )
        )
    }

    closeAlert(index: number) {
        this.alerts.splice(index, 1);
    }

    private showAlert(type: string, message: string) {
        const alert = {type: type, msg: message};
        this.alerts.push(alert);
        setTimeout(() => {
            const index = this.alerts.findIndex(x => x === alert);
            if (index >= 0) {
                this.closeAlert(index)
            }
        }, 5000);
    }
}

interface Alert {
    type: string
    msg: string
}